/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export enum AttachmentsViewState {
	SingleSelectMode = 'singleSelectMode', // default, list of files
	MultiSelectMode = 'multiSelectMode',
	FileCarouselView = 'fileCarouselView',
}

// specifically used by file-viewer.component
export enum FileViewState {
	Default = 'default',
	Selection = 'selection',
	Loading = 'loading',
	Error = 'error',
}
